import { render, staticRenderFns } from "./ViewFrame.vue?vue&type=template&id=41e68678&scoped=true&"
import script from "./ViewFrame.vue?vue&type=script&lang=js&"
export * from "./ViewFrame.vue?vue&type=script&lang=js&"
import style0 from "./ViewFrame.vue?vue&type=style&index=0&id=41e68678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e68678",
  null
  
)

export default component.exports